import { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import "../App.css";
import { toast } from "react-toastify";
import { DatePicker, Popconfirm, Select } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Link, useLocation } from "react-router-dom";
import ImportBulkExpenses from "../components/ImportBulkExpenses";
import { getRoute } from "../api/routes";
import api from "../Interceptor";
import { useSelector } from "react-redux";
import GetCurrencySymbol from "../components/GetCurrencySymbol";
import AddExpense from "./AddExpense";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faCaretDown,
  faCaretUp,
  faRefresh,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import CustomModal from "../components/customModal/customModal";
import { CustomInput } from "../components/ui";
import ModalFooter from "../components/customModal/modalFooter";
import useModal from "../hooks/useModal";
import { calculateTotals } from "../utils/calculateTotals";
import { fetchFilteredExpensesApi } from "../api/services/allExpenses";
import { validateFormHandler } from "../utils/validations/validateForm";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const { Option } = Select;

const ExpenseList = () => {
  const user = useSelector((state) => state.auth.user);

  const baseCurrency = localStorage.getItem("baseCurrency");
  const [expenses, setExpenses] = useState([]);
  const [filteredExpenses, setFilteredExpenses] = useState([]);
  const [filterType, setFilterType] = useState("All");
  const [selectedProject, setSelectedProject] = useState("All");
  const [selectedMilestone, setSelectedMilestone] = useState("All");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editExpense, setEditExpense] = useState(null);
  const tableRef = useRef(null);
  const [addTransactionModalVisible, setAddTransactionModalVisible] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [currencyView, setCurrencyView] = useState("BaseCurrency");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const { projectList } = useSelector((state) => state.app);
  const [milestoneList, setMilestoneList] = useState([]);
  const [errors, setErrors] = useState({});
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [currencyList, setCurrencyList] = useState([]);
  const [currencyFilter, setCurrencyFilter] = useState("All");
  const getAllCurrencies = async () => {
    try {
      const { data: currencyData } = await api.get(
        `${API_BASE_URL}/api/v1/getAllCurrencies`,
      );
      setCurrencyList(currencyData);
    } catch (error) {
      if (error?.isUnpaid) {
        return;
      }
      toast.error("Oops! Error while fetching Expenses");
    }
  };
  useEffect(() => {
    getAllCurrencies();
  }, []);
  const handleCurrencyFilterChange = (value) => {
    setCurrencyFilter(value);
  };
  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(order);

    const sorted = [...filteredExpenses].sort((a, b) => {
      if (field === "date") {
        return order === "asc"
          ? new Date(a.date) - new Date(b.date)
          : new Date(b.date) - new Date(a.date);
      }
      if (field === "amount") {
        const aAmount =
          currencyView === "BaseCurrency"
            ? a.amount / a.conversionRate
            : a.amount / a.conversionRate;
        const bAmount =
          currencyView === "BaseCurrency"
            ? b.amount / b.conversionRate
            : b.amount / b.conversionRate;

        return order === "asc" ? aAmount - bAmount : bAmount - aAmount;
      }
      return 0;
    });

    setFilteredExpenses(sorted);
  };
  const { isOpen, toggleModal } = useModal();
  const {
    income: totalIncome,
    expense: totalExpense,
    netProfit,
  } = calculateTotals(expenses);
  const handleAddTransaction = () => {
    setAddTransactionModalVisible(true);
  };

  const handleSuccess = () => {
    setAddTransactionModalVisible(false);
    fetchFilteredExpensesApi({
      userRole: user.userRole.name,
      selectedProject,
      selectedMilestone,
      startDate,
      endDate,
    }).then((data) => setExpenses(data));
  };

  const handleCurrencyChange = (value) => {
    setCurrencyView(value);
  };
  const fetchMilestones = async (projectId) => {
    try {
      const response = await api.get(
        `${getRoute(
          "users",
          `${user.userRole.name}`,
          `${user.userRole.name === "admin" ? "projects" : "milestone"}`,
          false,
          false,
          `${user.userRole.name === "admin" ? `milestone` : ""}`,
        )}?projectId=${projectId}`,
      );
      setMilestoneList(response.data);
    } catch (error) {
      toast.error("Error fetching milestones", error);
      return null;
    }
  };

  useEffect(() => {
    if (user?.userRole) {
      fetchFilteredExpensesApi({
        userRole: user.userRole.name,
        selectedProject,
        selectedMilestone,
        startDate,
        endDate,
      }).then((data) => setExpenses(data));
    }
  }, [selectedProject, selectedMilestone, startDate, endDate]);

  const handleStartDateChange = (date, dateString) => {
    setStartDate(dateString);
  };
  const handleEndDateChange = (date, dateString) => {
    setEndDate(dateString);
  };

  const handleProjectChange = (value) => {
    setSelectedProject(value);
    if (value !== "All") {
      fetchMilestones(value);
      setSelectedMilestone("All");
    } else {
      setMilestoneList([]);
      setSelectedMilestone("All");
    }
  };

  const handleMilestoneChange = (value) => {
    setSelectedMilestone(value);
  };
  useEffect(() => {
    let filtered = [...expenses];

    // Filter by Type
    if (filterType !== "All") {
      filtered = filtered.filter(
        (expense) => expense.type.toLowerCase() === filterType.toLowerCase(),
      );
    }

    // Filter by Currency
    if (currencyFilter !== "All") {
      filtered = filtered.filter(
        (expense) => expense.project?.currency?._id === currencyFilter,
      );
    }

    setFilteredExpenses(filtered);
  }, [expenses, filterType, currencyFilter]);

  const handleFilterTypeChange = (value) => {
    setFilterType(value);
  };
  const handleRefresh = () => {
    setCurrencyView("ProjectCurrency");
    setSelectedProject("All");
    setSelectedMilestone("All");
    setFilterType("All");
    setStartDate("");
    setEndDate(new Date().toISOString().split("T")[0]);
    setCurrencyFilter("All");
    fetchFilteredExpensesApi({
      userRole: user.userRole.name,
      selectedProject,
      selectedMilestone,
      startDate,
      endDate,
    }).then((data) => setExpenses(data));
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(
        `${getRoute(
          "users",
          `${user.userRole.name}`,
          "expenses",
          false,
        )}?id=${id}`,
      );
      toast.success("Transaction deleted successfully");
      fetchFilteredExpensesApi({
        userRole: user.userRole.name,
        selectedProject,
        selectedMilestone,
        startDate,
        endDate,
      }).then((data) => setExpenses(data));
    } catch (error) {
      toast.error("Failed to delete expense");
      console.error("Error deleting expense:", error);
    }
  };

  const handleUpdate = async (updatedExpense) => {
    const expenseId = updatedExpense._id;
    const hasChanged =
      updatedExpense.name !== editExpense.name ||
      updatedExpense.description !==
        (editExpense.description == undefined ? "" : editExpense.description) ||
      updatedExpense.amount !== editExpense.amount ||
      updatedExpense.type !== editExpense.type ||
      updatedExpense.date !== editExpense.date;
    if (!hasChanged) {
      toast.info("No changes detected.");
      return;
    }
    const updatedPayload = {
      name: updatedExpense.name,
      description: updatedExpense.description || undefined,
      amount: updatedExpense.amount,
      type: updatedExpense.type,
      conversionRate: updatedExpense.conversionRate,
      date: updatedExpense.date,
      project: updatedExpense.project._id,
      id: expenseId,
    };

    const validationErrors = validateFormHandler({
      name: updatedPayload.name,
      amount: updatedPayload.amount,
      date: updatedPayload.date,
    });
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setIsModalOpen(false);
    try {
      await api.put(
        `${getRoute(
          "users",
          `${user.userRole.name}`,
          "expenses",
          false,
        )}?id=${expenseId}`,
        updatedPayload,
      );
      setIsModalOpen(false);
      toast.success("Expense updated successfully");
      fetchFilteredExpensesApi({
        userRole: user.userRole.name,
        selectedProject,
        selectedMilestone,
        startDate,
        endDate,
      }).then((data) => setExpenses(data));
      closeModal();
    } catch (error) {
      console.error("Error updating project:", error);
      toast.error("Error updating project");
    }
  };
  const openEditModal = (expense) => {
    setEditExpense(expense);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditExpense(null);
  };
  const handleCreateTransaction = () => {
    if (!projectList || projectList.length === 0) {
      toast.info("Please create a project first before adding a transaction.");
      return;
    }
    toggleModal();
  };
  const location = useLocation();

  useEffect(() => {
    if (location.state?.openAddExpense) {
      handleCreateTransaction();
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);
  return (
    <div className="min-h-screen flex flex-col p-3 gap-2 overflow-hidden font-customFont">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div style={{ fontFamily: "Noto Serif, sans-serif" }}>
          <h1 className="font-bold text-lg md:text-xl">Transactions</h1>
          <p className="text-xs text-gray-500 font-semibold">
            Track and manage your income and expenses
          </p>
        </div>

        {/* Buttons Section */}
        {user.access !== process.env.REACT_APP_ACCESS_VIEW && (
          <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto my-3 md:my-0">
            {/* Import Bulk Expenses */}
            <div className="w-full md:w-auto">
              <ImportBulkExpenses />
            </div>

            {/* New Transaction */}
            <button
              className="bg-themeGradient text-white hover:bg-themeGradientHover px-3 py-1 rounded-md flex items-center justify-center w-full md:w-auto"
              onClick={handleCreateTransaction}
            >
              <i className="fa-solid fa-plus text-lg"></i>
              <span className="ms-2">New Transaction</span>
            </button>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {/* Total Net Income Card */}{" "}
        <div className="group relative overflow-hidden border border-blue-200 bg-gradient-to-br from-blue-50 via-white to-blue-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col sm:col-span-2 lg:col-span-1">
          <div className="absolute top-0 right-0 w-32 h-32 bg-blue-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faWallet}
                  className="text-white text-md"
                />
              </div>
              <p className="text-blue-700 text-sm font-semibold uppercase tracking-wide">
                Net Income
              </p>
            </div>
          </div>
          <p className="text-blue-900 text-3xl font-bold mt-1 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{" "}
            <span>{Math.floor(netProfit).toLocaleString()}</span>
            <span className="text-blue-600 text-xl">
              .{netProfit.toFixed(2).split(".")[1]}
            </span>
          </p>
          <p className="text-blue-600 text-xs mt-1 font-medium">
            Total profit after expenses
          </p>
        </div>
        {/* Total Income Card */}{" "}
        <div className="group relative overflow-hidden border border-green-200 bg-gradient-to-br from-green-50 via-white to-green-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col ">
          <div className="absolute top-0 right-0 w-32 h-32 bg-green-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faArrowTrendUp}
                  className="text-white text-md"
                />
              </div>
              <p className="text-green-700 text-sm font-semibold uppercase tracking-wide">
                Income
              </p>
            </div>
          </div>
          <p className="text-green-900 text-3xl font-bold mt-2 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{" "}
            <span>{Math.floor(totalIncome).toLocaleString()}</span>
            <span className="text-green-600 text-xl">
              .{totalIncome.toFixed(2).split(".")[1]}
            </span>
          </p>
          <p className="text-green-600 text-xs mt-1 font-medium">
            Total earnings received
          </p>
        </div>
        {/* Total Expense Card */}{" "}
        <div className="group relative overflow-hidden border border-red-200 bg-gradient-to-br from-red-50 via-white to-red-100 shadow-lg transition-all duration-300 rounded-2xl p-4 pb-3 flex flex-col">
          <div className="absolute top-0 right-0 w-32 h-32 bg-red-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faArrowTrendDown}
                  className="text-white text-md"
                />
              </div>
              <p className="text-red-700 text-sm font-semibold uppercase tracking-wide">
                Expense
              </p>
            </div>
          </div>
          <p className="text-red-900 text-3xl font-bold mt-2 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{" "}
            <span>{Math.floor(totalExpense).toLocaleString()}</span>
            <span className="text-red-600 text-xl">
              .{totalExpense.toFixed(2).split(".")[1]}
            </span>
          </p>
          <p className="text-red-600 text-xs mt-1 font-medium">
            Total amount spent
          </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row w-full justify-between gap-2">
        {/* Filters Section */}
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2 items-center">
          {/* Start Date */}
          <DatePicker
            id="startDate"
            placeholder="Start Date"
            value={startDate ? dayjs(startDate) : null}
            onChange={handleStartDateChange}
            disabledDate={(current) =>
              endDate ? current && current > dayjs(endDate) : false
            }
            className="w-full"
            style={{ borderRadius: "6px" }}
          />

          {/* End Date */}
          <DatePicker
            id="endDate"
            placeholder="End Date"
            value={endDate ? dayjs(endDate) : null}
            onChange={handleEndDateChange}
            disabledDate={(current) => {
              const today = dayjs().endOf("day");
              const minDate = startDate ? dayjs(startDate) : null;
              return (
                (current && current > today) || // prevent future dates
                (minDate && current < minDate) // prevent before startDate
              );
            }}
            className={`border border-gray-300 rounded-md py-1 px-2 w-full ${
              endDate ? "ring-1 ring-blue-500 rounded-md" : ""
            }`}
          />

          {/* Filter Type */}
          <Select
            defaultValue="All"
            id="filterType"
            onChange={handleFilterTypeChange}
            className="w-full"
            value={filterType}
          >
            <Option value="All">All Transactions</Option>
            <Option value="Income">Income</Option>
            <Option value="Expense">Expense</Option>
          </Select>

          {/* Project Filter */}
          <Select
            id="filterProject"
            value={selectedProject}
            onChange={handleProjectChange}
            className="w-full"
          >
            <Option value="All">All Projects</Option>
            {projectList.map((pro) => (
              <Option key={pro?._id} value={pro?._id}>
                {pro?.name}
              </Option>
            ))}
          </Select>

          {/* Milestone Filter (Hidden when 'All Projects' is selected) */}
          <Select
            id="filterMilestone"
            value={selectedMilestone}
            onChange={handleMilestoneChange}
            disabled={selectedProject === "All"}
            className="w-full"
          >
            <Option value="All">All Milestones</Option>
            {milestoneList.map((milestone) => (
              <Option key={milestone._id} value={milestone._id}>
                {milestone.name}
              </Option>
            ))}
          </Select>

          {/* Currency View */}
          <Select
            value={currencyView}
            onChange={handleCurrencyChange}
            className="w-full"
          >
            <Option value="BaseCurrency">Base Currency</Option>
            <Option value="ProjectCurrency">Project Currency</Option>
          </Select>
          <Select
            id="filterCurrencies"
            value={currencyFilter}
            onChange={handleCurrencyFilterChange}
            className="w-full"
          >
            <Option value="All">All Currencies</Option>
            {currencyList.map((cur) => (
              <Option key={cur?._id} value={cur?._id}>
                {cur?.symbol}
                {"_"}
                {cur?.name}
              </Option>
            ))}
          </Select>
        </div>

        {/* Reset Button */}
        <div className="flex justify-end md:items-center w-full md:w-auto">
          <button
            onClick={handleRefresh}
            className="text-[#000000e0] border border-[#DCE3E3] bg-white flex items-center justify-center w-full md:w-8 h-8 mb-3 md:mb-0 rounded-md"
          >
            <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        {loading ? (
          <div className="flex justify-center items-center h-48 mt-20">
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="relative w-full">
            {/* HORIZONTAL SCROLL (shared) */}
            <div className="overflow-x-auto">
              <div className="min-w-[800px] space-y-2">
                {/* ================= HEADER ================= */}
                <div className="rounded-lg border border-[#D5D7DA] shadow-sm bg-[#E9EAEB]">
                  <table className="w-full table-fixed">
                    <thead className="text-[#535862] font-semibold">
                      <tr>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                          Date
                        </th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                          Title
                        </th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                          Project
                        </th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                          Type
                        </th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                          Transactions
                        </th>
                        {user.access !== process.env.REACT_APP_ACCESS_VIEW && (
                          <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                            Action
                          </th>
                        )}
                      </tr>
                    </thead>
                  </table>
                </div>

                {/* ================= BODY ================= */}
                <div className="overflow-y-auto rounded-lg border border-[#D5D7DA] shadow-md bg-white">
                  <table className="w-full table-fixed">
                    <tbody className="divide-y divide-gray-200 text-[#535862]">
                      {filteredExpenses?.length === 0 ? (
                        <tr>
                          <td colSpan="6">
                            <div className="flex flex-col items-center justify-center my-20">
                              <i className="fa-solid fa-sack-dollar text-gray-400 text-5xl"></i>
                              <p className="text-gray-400 mt-4">
                                Please create an Expense to view its details.
                              </p>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        filteredExpenses.map((expense) => (
                          <tr key={expense._id}>
                            <td className="px-4 sm:px-6 py-4 text-sm">
                              {new Date(expense.date).toLocaleDateString()}
                            </td>

                            <td className="px-4 sm:px-6 py-4 text-sm">
                              {expense.name}
                            </td>

                            <td className="px-4 sm:px-6 py-4 text-sm">
                              <div className="flex items-center">
                                <img
                                  src="../icons/Projects.svg"
                                  className="mr-2 w-4 h-4 sm:w-5 sm:h-5"
                                  alt="project"
                                />
                                <span>{expense.project.name}</span>
                              </div>
                            </td>

                            <td className="px-4 sm:px-6 py-4">
                              <span
                                className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                  expense.type === "income"
                                    ? "bg-green-100 text-green-800"
                                    : "bg-red-100 text-red-800"
                                }`}
                              >
                                {expense.type === "income"
                                  ? "Income"
                                  : "Expense"}
                              </span>
                            </td>

                            <td
                              className={`px-4 sm:px-6 py-4 text-sm ${
                                expense.type === "income"
                                  ? "text-green-800"
                                  : "text-red-800"
                              }`}
                            >
                              {currencyView === "BaseCurrency" && (
                                <GetCurrencySymbol currencyId={baseCurrency} />
                              )}
                              {currencyView === "BaseCurrency"
                                ? ` ${(
                                    expense.amount / expense.conversionRate
                                  ).toFixed(2)}`
                                : `${
                                    expense.project.currency.symbol
                                  } ${expense.amount.toFixed(2)}`}
                            </td>

                            {user.access !==
                              process.env.REACT_APP_ACCESS_VIEW && (
                              <td className="px-4 sm:px-6 py-4">
                                <div className="flex gap-2">
                                  <button
                                    className="w-8 h-8 bg-blue-100 hover:bg-blue-200 text-blue-600 rounded-lg flex items-center justify-center transition-colors"
                                    onClick={() => openEditModal(expense)}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  <Popconfirm
                                    title="Are you sure you want to delete this expense?"
                                    onConfirm={() => handleDelete(expense._id)}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <button className="w-8 h-8 bg-red-50 hover:bg-red-100 text-red-600 rounded-lg flex items-center justify-center transition-colors">
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </Popconfirm>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {isOpen ? (
        <AddExpense
          onSuccess={handleSuccess}
          onCancel={toggleModal}
          isModalOpen={isOpen}
        />
      ) : null}

      <CustomModal
        isOpen={isModalOpen}
        onClose={closeModal}
        modalTitle="Edit Expense"
      >
        {editExpense && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              const updatedExpense = {
                ...editExpense,
                name: formData.get("name"),
                amount: parseFloat(formData.get("amount")),
                date: formData.get("date"),
                description: formData.get("description"),
                type: formData.get("type"),
              };

              handleUpdate(updatedExpense);
            }}
            className="space-y-4"
          >
            <div className="max-h-[50vh] scrollbar-hidden">
              <CustomInput
                type="text"
                name="name"
                label="Title"
                defaultValue={editExpense.name}
                onChange={() => {
                  if (errors.name) {
                    setErrors((prev) => ({ ...prev, name: undefined }));
                  }
                }}
                requir="true"
                message={errors.name}
              />
              <CustomInput
                type="text"
                name="project"
                label="Project"
                defaultValue={editExpense.project.name}
                message={errors.project}
                readOnly
              />
              <CustomInput
                type="number"
                name="amount"
                label="Amount"
                step="any"
                defaultValue={editExpense.amount}
                onChange={() => {
                  if (errors.amount) {
                    setErrors((prev) => ({ ...prev, amount: undefined }));
                  }
                }}
                message={errors.amount}
                requir="true"
              />
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">
                  Transaction Type
                </label>
                <div className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor flex justify-start gap-5">
                  <CustomInput
                    type="radio"
                    name="type"
                    value="income"
                    label="Income"
                    // checked={type === 'income'}
                    defaultChecked={editExpense.type === "income"}
                    // onChange={() => setType('income')}
                    className="custom-radio px-1 py-1"
                  />
                  <CustomInput
                    type="radio"
                    name="type"
                    value="expense"
                    label="Expense"
                    // checked={type === 'expense'}
                    defaultChecked={editExpense.type === "expense"}
                    // onChange={() => setType('expense')}
                    className="custom-radio"
                  />
                </div>
              </div>
              <CustomInput
                type="date"
                name="date"
                label="Date"
                defaultValue={
                  new Date(editExpense.date).toISOString().split("T")[0]
                }
                onChange={() => {
                  if (errors.date) {
                    setErrors((prev) => ({ ...prev, date: undefined }));
                  }
                }}
                max={new Date().toISOString().split("T")[0]}
                message={errors.date}
                requir="true"
              />
              <CustomInput
                as="textarea"
                name="description"
                label="Description"
                defaultValue={editExpense.description}
              />
            </div>
            <ModalFooter onCancel={closeModal} isLoading={loading} />
          </form>
        )}
      </CustomModal>
    </div>
  );
};

export default ExpenseList;
